const state = {
  userName: '',
  userToken: ''
}
const mutations = {
  SET_USER_NAME(state, name) {
    state.userName = name
  },
  SET_USER_TOKEN(state, userToken) {
    state.userToken = userToken
  }
}
const actions = {
  // 设置name
  setUserName({ commit }, name) {
    commit('SET_USER_NAME', name)
  },
  setUserToken({ commit }, userToken) {
    localStorage.setItem('userToken', userToken);
    commit('SET_USER_TOKEN', userToken)
  }
}
export default {
  state,
  mutations,
  actions
}
